define('lq/pullDownAction',["jquery"], function ($) {
    var getTouches = function (e) {
        return e.touches ||             // browser API
            e.originalEvent.touches; // jQuery
    };

    return {
        attach: function ($app, $wrapper, callback) {

            var startY = null;
            var shouldRefresh = false;
            var thresholdDistance = 150;
            var touchId = -1;
            var translateLength = 0;

            var $pullDownContainer = $("<div id='pull-down-container'></div>");

            var $pullDownIndicator = $(`<img id='pull-down-indicator' src=${require.toUrl("../Lq/pullDownAction.svg?bust=00001")}/>`)
                .appendTo($pullDownContainer);

            $app.append($pullDownContainer);

            $(document.documentElement).addClass('no-native-pull-down');
            $(document.body).addClass('no-native-pull-down');

            var handleTouchStart = function (e) {
                if (touchId > -1 || $wrapper.scrollTop() !== 0) return;

                var touch = getTouches(e)[0];
                startY = touch.screenY;

                touchId = touch.identifier;
            };

            var handleTouchMove = function (e) {
                if (!startY) {
                    return;
                }

                var touch = Array.from(e.changedTouches).find(function (t) { return t.identifier === touchId; });
                if (!touch) return;

                var distance = getTouches(e)[0].screenY - startY;
                shouldRefresh = distance >= thresholdDistance;

                if (distance > 0) {
                    translateLength = Math.min(distance, 120);

                    requestAnimationFrame(function () {
                        $app[0].style.overflow = 'hidden';
                        $app[0].style.webkitOverflowScrolling = 'touch';

                        $pullDownIndicator.css({
                            top: `${translateLength}px`,
                            transition: 'top 0.3s linear',
                            transform: `rotate(${translateLength * 3}deg)`
                        });
                    });
                }
            };

            var handleTouchEnd = function (e) {
                var touch = Array.from(e.changedTouches).find(function (t) { return t.identifier === touchId; });
                if (!touch) return;

                $app[0].style.overflowY = 'auto'
                touchId = -1;

                if (shouldRefresh) {
                    callback();
                    shouldRefresh = false
                }

                $app[0].style.overflow = 'hidden';
                $app[0].style.webkitOverflowScrolling = 'touch';

                $pullDownIndicator.css({
                    top: '-48px',
                    transition: 'top 0.1s linear'
                });

                $app[0].style.overflow = 'visible';

                removeEventListener('touchmove', handleTouchMove);
                removeEventListener('touchend', handleTouchEnd);
            };

            document.addEventListener('touchstart', handleTouchStart);
            document.addEventListener('touchmove', handleTouchMove);
            document.addEventListener('touchend', handleTouchEnd);
        }
    }
});

